export const SET_CONNECTION_STATUS = "SET_CONNECTION_STATUS";

export enum ConnectionStatusType {
  DISCONNECTED = "DISCONNECTED",
  CONNECTED = "CONNECTED",
  SECURED = "SECURED",
  LOGGED_IN = "LOGGED_IN",
}

export type ConnectionStateType = {
  connectionStatus: ConnectionStatusType;
};

export type SetConnectionStatusActionType = {
  type: typeof SET_CONNECTION_STATUS;
  payload: ConnectionStatusType;
};

export type ConnectionActionTypes = SetConnectionStatusActionType;
